import { render, staticRenderFns } from "./ReportsSubpage.vue?vue&type=template&id=289f06e6&"
import script from "./ReportsSubpage.vue?vue&type=script&lang=js&"
export * from "./ReportsSubpage.vue?vue&type=script&lang=js&"
import style0 from "./ReportsSubpage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports